import LegislativnyMaterialDetail
  from '../../../../model/legislativnyMaterial/LegislativnyMaterialDetail';
import { NotifikaciaTypEnum } from '../../../../model/notifikacia/NotifikaciaTyp';
import {
  hasBeenInStadium,
  hasBeenInUkonceneStadiumMpk,
} from '../../../../function/legMaterialFunctions';
import { StadiumMaterialuEnum } from '../../../../model/legislativnyMaterial/StadiumMaterialu';
import StadiumMaterialuHistoria
  from '../../../../model/legislativnyMaterial/StadiumMaterialuHistoria';

function getNotifikaciaHistoriaAdminActions(
  material: LegislativnyMaterialDetail,
  historiaRecords: Array<StadiumMaterialuHistoria>,
): Array<NotifikaciaTypEnum> {
  const options = [];

  if (StadiumMaterialuEnum.MPK === material?.stadium?.hodnota) {
    options.push(NotifikaciaTypEnum.SPUSTENIE_MPK);
  }

  if (hasBeenInUkonceneStadiumMpk(historiaRecords)) {
    options.push(NotifikaciaTypEnum.ZRUSENIE_MPK);
  }

  if (material?.typ?.kod === 'AktEU' && hasBeenInStadium(StadiumMaterialuEnum.SCHVALENIE_GESTORA, historiaRecords)) {
    options.push(NotifikaciaTypEnum.ZACIATOK_AKT_EU);
  }

  return options;
}

export {
  // eslint-disable-next-line import/prefer-default-export
  getNotifikaciaHistoriaAdminActions,
};
